<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
  <UNotifications />
  <DialogWrapper />
</template>

<script setup>
import { DialogWrapper } from 'vue3-promise-dialog'
const { $changeMainState } = useNuxtApp()

onMounted(async () => {
  $changeMainState({ isLoaded: true })
})
</script>
